import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type {
  DrilldownParams,
  DrilldownResponse,
  DrilldownRow,
} from '@/types/analyticsDrilldown'

/**
 * Liste paginée des enregistrements derrière un chiffre du dashboard manager.
 *
 * Backend : telephony/views.py::analytics_drilldown
 * Endpoint : GET /api/companies/{companyId}/analytics/drilldown/
 *
 * `keepPreviousData` évite le flash blanc quand on change de page (la page
 * précédente reste visible pendant le fetch).
 */
export function useAnalyticsDrilldown(
  companyId: number | undefined,
  params: DrilldownParams,
) {
  return useQuery({
    queryKey: ['analytics-drilldown', companyId, params],
    queryFn: async () => {
      const { data } = await api.get<DrilldownResponse<DrilldownRow>>(
        `/api/companies/${companyId}/analytics/drilldown/`,
        { params },
      )
      return data
    },
    enabled: Boolean(companyId) && Boolean(params.metric),
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  })
}
